export default "__VITE_ASSET__ZAzeLPCA__"